
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 14.667A6.667 6.667 0 118 1.334a6.667 6.667 0 010 13.333zm0-1.333A5.333 5.333 0 108 2.667a5.333 5.333 0 000 10.667zm-.667-3.333h1.333v1.333H7.333v-1.333zm1.333-1.097v.43H7.333v-1c0-.368.298-.667.667-.667a1 1 0 10-.981-1.196L5.71 6.21a2.334 2.334 0 112.955 2.694z","fill":"#FC6713"}})])
          )
        }
      }
    